var map = {
	"./iphone6-tpu-mask.svg": 225,
	"./iphone7-tpu-mask.svg": 226,
	"./iphone8-tpu-mask.svg": 227,
	"./iphone8plus-tpu-mask.svg": 228,
	"./note9-tpu-mask.svg": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224;